import React from 'react';

const InboxStickyNote = ({ size = 24, className = '', svgClassName = 'text-blue-600', style = {}, ...rest }) => {
  return (
    <div
      className={`rounded-lg w-fit cursor-pointer ${className}`}
      style={style}
      {...rest}
    >
      {/* <svg
        viewBox="-3.6 -3.6 31.20 31.20"
        xmlns="http://www.w3.org/2000/svg"
        className={`${svgClassName}`}
        fill="none"
        stroke="currentColor"
        width={size}
        height={size}
      >
        <path
          d="M8.73,5.23,4.78,9.18a6.1,6.1,0,0,0,0,8.61h0a6.09,6.09,0,0,0,8.6,0l6.43-6.43a4,4,0,0,0,0-5.74h0a4.06,4.06,0,0,0-5.73,0L7.34,12.36a2,2,0,0,0,0,2.87h0a2,2,0,0,0,2.87,0l7-7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg> */}

      <svg 
        width={size}
        height={size}
        viewBox="0 0 20 20" 
        className={`${svgClassName}`}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_29062_4755)">
        <path d="M11.1324 19.1213C11.1203 19.1213 11.109 19.125 11.0969 19.125H3.44872C2.02896 19.125 0.875 17.971 0.875 16.5513V3.44872C0.875 2.02896 2.02896 0.875 3.44872 0.875H16.5513C17.971 0.875 19.125 2.02896 19.125 3.44872V11.0959C19.125 11.1212 19.1184 11.1446 19.1175 11.1699H13.7062C12.2864 11.1699 11.1324 12.3238 11.1324 13.7436V19.1213ZM13.7062 12.5737C13.0613 12.5737 12.5363 13.0988 12.5363 13.7436V18.6833C12.6711 18.5915 12.7993 18.4886 12.9163 18.3707L18.3707 12.9163C18.4764 12.8105 18.5681 12.6935 18.6524 12.5737H13.7062Z" fill="url(#paint0_linear_29062_4755)"/>
        </g>
        <defs>
        <linearGradient id="paint0_linear_29062_4755" x1="0.266667" y1="17.0071" x2="17.0071" y2="0.266667" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F6A723"/>
        <stop offset="1" stop-color="#FFDD55"/>
        </linearGradient>
        <clipPath id="clip0_29062_4755">
        <rect width="20" height="20" fill="white"/>
        </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default InboxStickyNote;
